import { render, staticRenderFns } from "./SoUpdate.vue?vue&type=template&id=33c9a8ef&scoped=true&"
import script from "./SoUpdate.vue?vue&type=script&lang=js&"
export * from "./SoUpdate.vue?vue&type=script&lang=js&"
import style0 from "./SoUpdate.vue?vue&type=style&index=0&id=33c9a8ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c9a8ef",
  null
  
)

export default component.exports